import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Compatibility hook that mimics the old react-translate API
 * Usage: const t = useTranslate('Footer');
 *        t('AllRightsReserved') -> looks up Footer.AllRightsReserved
 */
const useTranslate = (namespace) => {
  const { t: i18nT } = useTranslation();

  const t = useCallback(
    (key, params) => {
      const fullKey = namespace ? `${namespace}.${key}` : key;
      return i18nT(fullKey, params);
    },
    [namespace, i18nT]
  );

  return t;
};

export { useTranslate };
export default useTranslate;

